import { render, staticRenderFns } from "./IconInHospitalBlack.vue?vue&type=template&id=c725a286"
import script from "./IconInHospitalBlack.vue?vue&type=script&lang=js"
export * from "./IconInHospitalBlack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports